<template>
  <el-dialog
    title="Cupón"
    v-on="$listeners"
    v-bind="$attrs"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <!-- @closed="handleClose" -->
    <div>
      <ul v-if="couponList.length">
        <li v-for="item in couponList" @click="chooseCoupon(item)">
          <!-- 左侧金额/天数/折扣文案展示 -->
          <div
            class="leftTitle"
            :style="{
              color: couponColor[item.coupon_type],
              background: couponBgcColor[item.coupon_type],
            }"
          >
            <div style="display: flex;align-items: baseline;">
              <span v-show="item.coupon_type == 1">-</span>
              {{ item.distribute_amount }}
              <span style="font-size: 0.3rem;margin-left: 0.03rem;">
                {{ couponAmountText[item.coupon_type] }}
              </span>
            </div>
          </div>
          <!-- 右侧详情文案/时间展示 -->
          <div class="rightContent">
            <h5>{{ couponName[item.coupon_type] }}</h5>
            <h3>{{ couponDesc[item.coupon_type] }}</h3>
            <p>
              Vencimiento: {{ $setMoment(item.effective_date, 1) }} -
              {{ $setMoment(item.expire_date, 1) }}
            </p>
          </div>

          <!-- 未选中 -->
          <transition name="fade">
            <img
              v-show="!item.checked"
              src="../../assets/images/noCheck.png"
              alt=""
            />
          </transition>
          <!-- 选中 -->
          <transition name="fade">
            <img
              v-show="item.checked"
              src="../../assets/images/checked.png"
              alt=""
            />
          </transition>
        </li>
      </ul>

      <ul style="height: 4.5rem;" v-else>
        <div>
          <img src="../../assets/images/couponEmpty.png" alt="" />
          <p>Aún no hay cupones</p>
        </div>
      </ul>
    </div>
    <!-- 确认使用优惠券 -->
    <div class="footBox" v-if="couponList.length">
      <div class="confirmBtn" @click="confirmUseCoupon">Confirmar</div>
    </div>
  </el-dialog>
</template>

<script>
import { getUseableCouponList } from "../../utils/api/h5page";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      loanState: 0, // 1 首贷确认订单页 2 复贷首页 3 还款页
      couponBgcColor: {
        1: "#FFEFEF", // 减免券背景颜色
        4: "#E4EFFF", // 提额券背景颜色
        5: "#E6FFF2", // 延期券背景颜色
        6: "#FFF1E6", // 折扣券背景颜色
      },
      couponColor: {
        1: "#D23D34", // 减免券字体颜色
        4: "#4244B7", // 提额券字体颜色
        5: "#2AAC76", // 延期券字体颜色
        6: "#CB844B", // 折扣券字体颜色
      },
      couponAmountText: {
        1: "", // 减免
        4: "", // 提额
        5: "días", // 延期券
        6: "%", // 折扣券
      },
      couponDesc: {
        1: "Hacer que reduzca la cantidad del préstamo a pagar", // 减免券
        4: "Hacer que obtenga más préstamos", // 提额券
        5: "Permitirle extender el número de días del préstamo", // 延期券
        6: "Puede reducir los intereses de su pedido según el descuento del cupón de descuento",
      },
      couponName: {
        1: "Cupón para reducir el pago", // 减免券
        4: "Cupón de aumento de límite", // 提额券
        5: "Cupón de extensión de plazo", // 延期券
        6: "Cupón de descuento", // 折扣券
      },
      couponList: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 判断当前优惠券所处页面
    setloanState(type) {
      this.loanState = type;
      if (type == 3) {
        this.getCouponList(1);
      } else {
        this.getCouponList(4);
      }
    },

    // 优惠券回显
    showCouponData(arr) {
      this.couponList.forEach((item) => {
        arr.map((val) => {
          if (item.id == val.id) {
            item.checked = true;
          }
        });
      });
    },

    // 选中优惠券
    chooseCoupon(row) {
      let chooseArr = this.couponList.filter((item) => item.checked);
      // 1. 首先更新当前点击项状态
      this.couponList.forEach((item) => {
        if (item.id === row.id) {
          item.checked = !item.checked;
        }
      });
      // 还款页时 单选互斥
      if (this.loanState === 3) {
        this.couponList.forEach((item) => {
          if (item.id !== row.id) {
            item.checked = false;
          }
        });
      }
      // 借款时 多选 条件互斥
      else {
        chooseArr.forEach((checkedItem) => {
          // 跳过当前点击项;
          if (checkedItem.id === row.id) return;
          // 类型相同互斥
          if (row.coupon_type == checkedItem.coupon_type) {
            checkedItem.checked = false;
          }
          // 4 提额 与 延期券互斥 当前选中提额 延期取消
          else if (row.coupon_type == 4 && checkedItem.coupon_type == 5) {
            checkedItem.checked = false;
          }
          // 5 延期 与 提额券互斥 当前选中延期 提额取消
          else if (row.coupon_type == 5 && checkedItem.coupon_type == 4) {
            checkedItem.checked = false;
          }
        });
      }
    },
    // 确认使用优惠券
    confirmUseCoupon() {
      let checked_coupon_id_list = this.couponList.filter(
        (item) => item.checked
      );
      // 还款单选优惠券
      if (this.loanState == 3) {
        this.$emit("useCoupon", checked_coupon_id_list[0].id);
      }
      // 借款多选优惠券
      else {
        let couponIdList = checked_coupon_id_list.map((item) => item.id);
        this.$emit("useCoupon", couponIdList, checked_coupon_id_list);
      }
    },

    // 获取优惠券列表
    getCouponList(coupon_type) {
      getUseableCouponList({
        offset: 0,
        coupon_type,
        ui_version: "231109",
        app_version_code: "10",
      }).then(({ data }) => {
        this.couponList = data.data.data.map((item) => {
          return { ...item, checked: false };
        });
        setTimeout(() => {
          if (this.loanState !== 3) {
            this.firstChooseCoupon();
          }
        }, 10);
      });
    },

    // 优惠券默认选中
    firstChooseCoupon() {
      // 借款处理优惠券
      let descuentos = this.couponList.some((item) => item.coupon_type == 6);
      // 有折扣券时
      if (descuentos) {
        // 选中第一张折扣券（类型6）
        const discountCoupon = this.couponList.find(
          (item) => item.coupon_type === 6
        );
        if (discountCoupon) discountCoupon.checked = true;

        // 选中第一张提额/延期券（类型4或5） 只选第一张而非全部
        const otherCoupon = this.couponList.find(
          (item) => item.coupon_type === 4 || item.coupon_type === 5
        );
        if (otherCoupon) otherCoupon.checked = true;
        setTimeout(() => {
          this.confirmUseCoupon();
        }, 10);
      }
      // 没折扣券默认选择第一个 优惠券
      else {
        if (this.couponList.length > 0) {
          this.couponList[0].checked = true;
        }
        this.confirmUseCoupon();
      }
    },

    // 关闭弹窗触发
    // handleClose() {
    //   if (this.loanState === 3) {
    //     this.getCouponList(1);
    //   } else {
    //     this.getCouponList(4);
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  position: relative;
  width: 12rem;
  border-radius: 0.2rem;
  .el-dialog__header {
    width: 100%;
    height: 1.85rem;
    padding: 0;
    background: linear-gradient(180deg, #ffdcdc 0%, #ffffff 100%);
    border-radius: 0.2rem 0.2rem 0rem 0rem;
    text-align: center;
    padding-top: 0.32rem;
    line-height: 0;
    span {
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 0.3rem;
      color: #333333;
    }
    .el-dialog__headerbtn {
      font-size: 0.4rem;
      top: 0.27rem;
      right: 0.22rem;
    }
  }
}
::v-deep .el-dialog__body {
  margin-top: -0.65rem;
  padding-bottom: 0;
}
ul {
  display: flex;
  position: relative;
  //   padding: 0 0.2rem;
  min-height: 3rem;
  max-height: 7.25rem;
  overflow-y: auto;
  flex-wrap: wrap;
  justify-content: space-between;
  li {
    cursor: pointer;
    position: relative;
    display: flex;
    width: 49.3%;
    height: 1.3rem;
    background: #ffffff;
    border-radius: 0.16rem;
    border: 0.01rem solid #d0d0d0;
    &:nth-child(2n) {
      margin-right: 0;
    }
    .leftTitle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.3rem;
      height: 100%;
      background: #e4efff;
      border-radius: 0.16rem;
      border: 0.02rem solid #ffffff;
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 0.36rem;
      line-height: 0.54rem;
    }

    .rightContent {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 0.15rem;
      h5 {
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 0.17rem;
        color: #333333;
      }
      h3 {
        width: 3.14rem;
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 0.17rem;
        color: #333333;
        margin: 0.03rem 0;
        line-height: 0.2rem;
      }
      p {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.16rem;
        color: #999999;
      }
    }

    img {
      position: absolute;
      width: 0.28rem;
      height: 0.28rem;
      right: 0.2rem;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  & > div {
    position: absolute;
    left: 50%;
    top: 0.5rem;
    transform: translateX(-50%);
    text-align: center;
    img {
      width: 2.1rem;
      height: 2rem;
    }
    p {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.26rem;
      color: #666666;
      line-height: 0.38rem;
    }
  }
}

.footBox {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.33rem 0;
  .confirmBtn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4.9rem;
    height: 0.7rem;
    background: #c90000;
    box-shadow: inset 0rem 0.16rem 0.32rem 0rem rgba(255, 255, 255, 0.22);
    border-radius: 0.4rem;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.28rem;
    color: #ffffff;
  }
}
</style>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
